<a routerLink="/" class="brand-block brand-block--stacked" (click)="onBrandClick()">
  <img
    class="brand-logo brand-logo--compact"
    [src]="logoUrl"
    width="52"
    height="52"
    alt="Prayagraj Development Authority (PDA) logo"
  />
  <div class="brand-text brand-text--stacked">
    <p class="org-name">{{ ORG.fullName.en }}</p>
    <p class="org-alt hi-line">{{ ORG.fullName.hi }}</p>
    @if (moduleTag) {
      <span class="module-tag">{{ moduleTag }}</span>
    }
  </div>
</a>
